import React, { useEffect, Fragment } from 'react';
import { Link } from "react-router-dom";
import headerLogo from "./img/header-logo.svg";
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import { translate } from 'react-i18next';

const useStyles = makeStyles(() => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
    },
    paper: {
        display: 'inline-block',
        maxHeight: '100vh',
        overflow: 'auto',
        width: '100%'
    },
}));

function RulesNonCustomerModal(props) {
    const classes = useStyles();
    // const [open, setOpen] = React.useState(false);

    // useEffect(() => {
    //     setOpen(props.open);
    // }, [props.open])

    return (
        <Modal
            open={props.open}
            classes={classes.modal}
            aria-labelledby="spring-modal-title"
            aria-describedby="spring-modal-description">
            <Fade in={props.open}>
                <div className={classes.paper}>
                    <div className="registration">
                        <Link to="/">
                            <img src={headerLogo} className="registration-logo" alt="headerLogo" />
                        </Link>
                        <div className="registration-rules-container registration-rules-container-non registration-container">
                            <div className="registration-rules-container-content">
                                <div className="registration-rules-container-content-header">
                                    <h4>{props.t('Before registering in the application, please review the following rules')}</h4>
                                </div>
                                <ol className="registration-rules-container-content-list registration-rules-container-content-list-non registration-container-description">
                                    <li className="registration-rules-container-content-item">{props.t('rules-text1')}</li>
                                    <li className="registration-rules-container-content-item">{props.t('rules-text2')}</li>
                                    <li className="registration-rules-container-content-item">{props.t('rules-text3')}</li>
                                    <li className="registration-rules-container-content-item">{props.t('rules-text4')}</li>
                                    <li className="registration-rules-container-content-item">{props.t('rules-text5')}</li>
                                    <li className="registration-rules-container-content-item">{props.t('rules-text6')}</li>
                                    <li className="registration-rules-container-content-item">{props.t('rules-text7')}</li>
                                    <li className="registration-rules-container-content-item">{props.t('rules-text8')}</li>
                                    <li className="registration-rules-container-content-item">{props.t('rules-text9')}</li>
                                    <li className="registration-rules-container-content-item">{props.t('rules-text10')}</li>
                                </ol>
                            </div>
                            <div className="registration-rules-container-footer registration-container-footer">
                                <button onClick={() => props.closeFunction()} className="registration-container-footer-button registration-container-footer-button--left">{props.t('i do not agree')}</button>
                                <button onClick={() => props.function()} className="registration-container-footer-button registration-container-footer-button--right registration-container-footer-button--active">{props.t('agree')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}

export default translate("translation")(RulesNonCustomerModal);